export const TEST_SHOE = {
    name: "Soft 7",
    articleNumber: "440303",
    dominantColor: "01001",
};

export const INPUT_FIRST_NAME = 'input[name="firstName"]';
export const INPUT_LAST_NAME = 'input[name="lastName"]';
export const INPUT_EMAIL = 'input[name="email"]';
export const INPUT_PASSWORD = 'input[name="password"]';
export const BUTTON_SUBMIT = 'button[type="submit"]';
export const HEADING_1 = "h1";
export const IFRAME = "iframe";

// Prefix for page navigation link data-testids, e.g. `page-nav-link-addresses`.
// The suffix is the stable English last path segment of the link's slug.
export const PAGE_NAV_LINK_TEST_ID_PREFIX = "page-nav-link";

export const DEFAULT_DISABLED_RULES: string[] = [
    "document-title",
    "meta-viewport",
    "color-contrast",
    "region",
    "svg-img-alt",
    "heading-order",
    "frame-title",
];
